import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { CreditAgreementSectionWip } from '~/packages/creditAgreements/ui/creditAgreementWip/CreditAgreementWip';

// Types
const RouteParamsStruct = z.object({
  creditFacilityId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { creditFacilityId } = RouteParamsStruct.parse(params);
  return (
    <CreditAgreementSectionWip
      creditFacilityId={creditFacilityId}
      section="borrowingBaseMechanics"
    />
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings/credit-facilities" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
